import { render, staticRenderFns } from "./addGatewaymodal.vue?vue&type=template&id=5ac99b36"
import script from "./addGatewaymodal.vue?vue&type=script&lang=js"
export * from "./addGatewaymodal.vue?vue&type=script&lang=js"
import style0 from "./addGatewaymodal.vue?vue&type=style&index=0&id=5ac99b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports